import { useState } from "react";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";

export default function AccountPage() {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "" });
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  const changePassword = async (event) => {
    event.preventDefault();
    setStatus(""); setError("");
    try {
      await api.patch("/account/password", form);
      setStatus("Passwort wurde geändert.");
      setForm({ current_password: "", new_password: "" });
    } catch (err) {
      setError(err.response?.data?.detail || "Passwort konnte nicht geändert werden.");
    }
  };

  const canUseLuisaStyle = ["l.mutz@dosa-industrietechnik.de", "admin@shop.de"].includes(user?.email);
  const changeTheme = async (event) => {
    setStatus(""); setError("");
    try {
      const { data } = await api.patch("/account/theme", { theme_style: event.target.value });
      updateUser(data);
      setStatus(data.theme_style === "luisa" ? "Luisa Style wurde aktiviert." : "Standard-Design wurde aktiviert.");
    } catch (err) {
      setError(err.response?.data?.detail || "Erscheinungsbild konnte nicht geändert werden.");
    }
  };

  return <main className="page" data-testid="account-page">
    <section className="page-hero compact"><span data-testid="account-eyebrow">Account</span><h1 data-testid="account-title">Ihre Kundendaten.</h1></section>
    <section className="account-detail-grid"><div className="account-info-card" data-testid="account-info-card"><h2>Kundeninformationen</h2><dl><div><dt>Name</dt><dd data-testid="account-name">{user?.name}</dd></div><div><dt>E-Mail</dt><dd data-testid="account-email">{user?.email}</dd></div><div><dt>Rolle</dt><dd data-testid="account-role">{user?.role === "admin" ? "Admin" : "Kunde"}</dd></div></dl>{canUseLuisaStyle && <div className="theme-control" data-testid="luisa-style-control"><label>Erscheinungsbild<select value={user?.theme_style === "luisa" ? "luisa" : "standard"} onChange={changeTheme} data-testid="luisa-style-select"><option value="standard">Standard</option><option value="luisa">Luisa Style</option></select></label></div>}</div>
    <form className="account-info-card" onSubmit={changePassword} data-testid="password-change-form"><h2>Passwort ändern</h2><label>Aktuelles Passwort<input type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="current-password-input" /></label><label>Neues Passwort<input type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="new-password-input" /></label>{status && <div className="status-line" data-testid="password-change-status">{status}</div>}{error && <div className="error" data-testid="password-change-error">{error}</div>}<button className="primary-button" type="submit" data-testid="password-change-submit">Passwort speichern</button></form></section>
  </main>;
}